{
  "checkBackSoonMessage": "We hope to have this feature up and running shortly. Check back soon!",
  "contactUs": "Contact Us",
  "errorBoundaryTitle": "Something Went Wrong",
  "featureInProgressMobileWithWebappUrl": "We are working on porting this feature from our web-app to mobile platforms.\nIn the meantime, you can use this feature at {{webappUrl}}",
  "loadErrorDismissButton": "Dismiss",
  "retryButton": "Retry",
  "loadErrorMessage": "Our team has been notified and is working to resolve the issue.",
  "loadErrorSupportTicketLink": "Create a support ticket",
  "loadErrorSupportTicketMessage": "Create a support ticket to track your issue.",
  "loadErrorTitle": "Something Went Wrong",
  "notFoundMessage": "The content you requested does not exist.",
  "notFoundTitle": "Not Found",
  "permissionDeniedHowToGetPermissionHint": "To gain access to this feature, contact an administrator of your farm account.",
  "permissionDeniedMessage": "You do not have permission to perform this action.",
  "permissionDeniedMissingPermissions": "Missing Permissions: ",
  "permissionDeniedTitle": "Permission Denied",
  "reloadButton": "Reload",
  "underConstruction": "Under Contruction"
}
